import Section from "@/components/Section";
import { ROUTES } from "@/utils/navigation";
import { Box, Button, CardMedia, Typography } from "@mui/material";
import character_url from "@/assets/icons/help-desk/character.svg";
import { Link } from "react-router-dom";

const ContactUsSection = () => {
  return (
    <Section pt={{ xs: 3.75, md: 6.25 }} pb={{ xs: 7.5, md: 15 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(12, 1fr)",
          padding: { xs: "16px 30px", md: "52px 80px 25px 68px" },
          border: "1px solid #CCCCCC",
          borderRadius: "12px",
        }}
      >
        <Box
          sx={{
            gridColumn: { xs: "span 12", md: "span 8" },
            gridRow: "span 1",
            display: "flex",
            alignItems: "end",
            paddingBottom: "20px",
          }}
        >
          <Typography
            variant="h2"
            component="p"
            sx={{
              textAlign: { xs: "center", md: "start" },
              width: "100%",
            }}
          >
            If you need more help or have specific questions, feel free to contact us directly
          </Typography>
        </Box>
        <Box
          sx={{
            gridColumn: { xs: "span 12", md: "span 8" },
            gridRow: "span 1",
            order: "2",
            paddingTop: "20px",
            display: "flex",
            justifyContent: { xs: "center", md: "start" },
          }}
        >
          <Button
            component={Link}
            to={ROUTES.contactUs}
            variant="contained"
            color="primary"
            disableElevation
            sx={{
              paddingY: "14px",
              paddingX: "65px",
              height: "50px",
              textWrap: "nowrap",
              maxWidth: "282px",
              width: "100%",
            }}
          >
            Contact us
          </Button>
        </Box>
        <Box
          sx={{
            gridColumn: { xs: "span 12", md: "span 4" },
            gridRow: "span 2",
            display: "flex",
            justifyContent: { xs: "center", md: "end" },
          }}
        >
          <CardMedia
            component="img"
            image={character_url}
            alt="character"
            width="100%"
            height="auto"
            sx={{ maxWidth: { xs: "205px", md: "391px" } }}
          />
        </Box>
      </Box>
    </Section>
  );
};

export default ContactUsSection;
